import { createContext, useContext, useMemo, useState } from 'react';
import { getDefaultDateRange, getPresetRange } from '../utils/dateRanges';

const DateRangeContext = createContext(null);

export function DateRangeProvider({ children }) {
  const [range, setRangeState] = useState(() => ({ ...getDefaultDateRange(), preset: 'This Month' }));

  function applyPreset(label) {
    setRangeState({ ...getPresetRange(label), preset: label });
  }

  function setRange(nextRange) {
    setRangeState({ ...nextRange, preset: nextRange.preset || 'Custom Range' });
  }

  const value = useMemo(() => ({
    startDate: range.startDate,
    endDate: range.endDate,
    selectedPreset: range.preset || 'Custom Range',
    setStartDate: (startDate) => setRangeState((current) => ({ ...current, startDate, preset: 'Custom Range' })),
    setEndDate: (endDate) => setRangeState((current) => ({ ...current, endDate, preset: 'Custom Range' })),
    setRange,
    applyPreset,
  }), [range]);

  return <DateRangeContext.Provider value={value}>{children}</DateRangeContext.Provider>;
}

export function useDateRange() {
  const value = useContext(DateRangeContext);
  if (!value) throw new Error('useDateRange must be used inside DateRangeProvider');
  return value;
}
